module.exports = __webpack_public_path__ + "static/media/plus-circle.9a7d9668.svg";